import { Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { VerifyOffer } from './VerifyOffer';

const VERDICT = "Couldn't verify this selection.";
const ACTION_LABEL = 'Would you like me to remove it from the document?';

type VerifyCalloutProps = {
  /** Hands the verify context off to the normal document editor pass. */
  onAction: () => void;
  /** The model's short spoken answer; replaces the canned verdict copy when present. */
  message?: string;
  /** Sidebar is dark (Siesta chats): use light text against the dark background. */
  dark?: boolean;
};

/** Shown only when the transcript has no evidence at all — the sole "couldn't verify" state. */
export function VerifyCallout({ onAction, message, dark }: VerifyCalloutProps) {
  const spokenReply = message?.trim();
  return (
    <Stack gap="sm">
      {/* Match VerifyResult: a spoken reply reads as medium-weight body text. */}
      <Text
        size="textSm"
        fw={spokenReply ? FONT_WEIGHTS.medium : undefined}
        c={dark ? 'gray.2' : 'gray.8'}
      >
        {spokenReply || VERDICT}
      </Text>
      <VerifyOffer label={ACTION_LABEL} dark={dark} onClick={onAction} />
    </Stack>
  );
}
